<div fxLayout="column" fxFill fxLayoutAlign="center center">
  <div [ngClass]="routeAnimationsElements" class="heading">
    <div>Authorization Denied</div>
  </div>
  <p [ngClass]="routeAnimationsElements">
    You do not have the required roles to access the requested resource.
  </p>
  <p>
    Please log a call to request access.
  </p>
  <p [ngClass]="routeAnimationsElements">
    <button class="home-button" routerLink="/" mat-icon-button>
      <mat-icon aria-label="Home">home</mat-icon>
    </button>
  </p>
  <div [ngClass]="routeAnimationsElements">
    <div *ngIf="theme !== 'dark-theme'">
      <img class="sgit-logo" width="200px" src="assets/splash-small-light.png" />
    </div>
    <div *ngIf="theme === 'dark-theme'">
      <img class="sgit-logo" width="200px" src="assets/splash-small-dark.png" />
    </div>
  </div>
</div>